import { Trans } from '@lingui/react'

import {
  Headline,
  HeadlineIcon,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigContractIcon } from '@twisto/icons'

import * as styles from './pl-basic-account-agreements-step-header.styles'

export const PlBasicAccountAgreementsStepHeader = () => (
  <Headline css={styles.header}>
    <HeadlineIcon>
      <BigContractIcon color="primary" height="100%" width="100%" />
    </HeadlineIcon>
    <HeadlineTitle>
      <Trans id="flow.plBasicAccountAgreements.title" />
    </HeadlineTitle>
  </Headline>
)
